import { render, staticRenderFns } from "./GradeDetail.vue?vue&type=template&id=b82cbeb6&scoped=true"
import script from "./GradeDetail.vue?vue&type=script&lang=js"
export * from "./GradeDetail.vue?vue&type=script&lang=js"
import style0 from "./GradeDetail.vue?vue&type=style&index=0&id=b82cbeb6&prod&scoped=true&lang=less"
import style1 from "./GradeDetail.vue?vue&type=style&index=1&id=b82cbeb6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82cbeb6",
  null
  
)

export default component.exports